import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import actions from "actions";
import constants from "constants";
import StatisticsView from "components/Admin/StudyGroups/Statistics/Statistics";

const { loadAdminAdminDashboardWebinarsSaga, showDashboardModalSaga } = actions;

const { MODAL_TYPE_DASHBOARD } = constants;

class Statistics extends Component {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    dispatch: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      query: {
        register_from: null,
        register_to: null,
        logged_from: null,
        logged_to: null,
        user_type: null,
        county: null,
        hospital: "",
      },
    };
  }

  componentWillMount() {
    this.props.loadWebinars(this.state.page, {
      group_id: this.props.params.id,
    });
  }

  onChangePage = (page = 1) => {
    this.setState(
      {
        page,
      },
      () => {
        this.props.loadWebinars(this.state.page, {
          group_id: this.props.params.id,
        });
      }
    );
  };

  changeQuery = (query) => {
    this.setState({ query }, () => {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(this.loadStatistics, 500);
    });
  };

  onChangeQuery = (field, value) => {
    const query = { ...this.state.query, ...{ [field]: value } };
    this.changeQuery(query);
  };

  onDateRangeChange = (field, start, end) => {
    const query = {
      ...this.state.query,
      ...{ [`${field}_from`]: start, [`${field}_to`]: end },
    };
    this.changeQuery(query);
  };

  loadStatistics = () => {
    this.props.loadStatistics(this.state.query);
  };

  showUsersModal = (webinar_id, type, count, additional = {}) => {
    if (count != 0)
      this.props.showUsersModal(
        {
          webinar_id: webinar_id,
          type: type,
        },
        additional
      );
  };

  render() {
    const { webinars, count } = this.props;

    return (
      <StatisticsView
        webinars={webinars}
        webinarsCount={count}
        showUsersModal={this.props.user_role === "admin" && this.showUsersModal}
        paginationProps={{
          onChangePage: this.onChangePage,
          page: this.state.page,
          total_pages: this.props.total_pages,
        }}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    webinars: state.webinars.dashboardWebinars.values,
    count: state.webinars.dashboardWebinars.count,
    total_pages: state.webinars.dashboardWebinars.total_pages,
    user_role: state.users.user.role,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    loadWebinars: (page, params) =>
      dispatch(loadAdminAdminDashboardWebinarsSaga(page, params)),
    showUsersModal: (contentProps, additional = {}) =>
      dispatch(
        showDashboardModalSaga(MODAL_TYPE_DASHBOARD, contentProps, additional)
      ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Statistics);



// WEBPACK FOOTER //
// ./src/containers/Admin/StudyGroups/Statistics.jsx